import { Tab as BaseTab } from '@aibees/shared/components';
import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
export const Wrapper = styled(Tabs)`
  padding: ${(p) => p.theme.spacing(0, 1.5)};
`;

export const Tab = styled(BaseTab)``;
